declare const window: any;
export default (eventName: string, options: any): void => {
    const dataLayer = window.dataLayer || [];
    dataLayer.push({
        event: eventName,
        ...options,
    });
};